import Vue from "vue";
import Router from "vue-router";
import store from "../store/index";
// 二级菜单
import {

  //-------------订单管理------------
  orderrecord, //订单记录
  returnrecord, //退单记录
  financialSettlement, //结算
  //-------------业务管理------------
  card, //会员卡管理
  prepaid, //充值记录
  //-------------审核管理------------
  adver, //广告管理
  notice, //公告管理
  control, //监控管理
  // ---------用户管理-----------
  user, //普通用户管理
  consultant,
  pharmacist, //咨询师管理
  //-------------- 系统管理---------------
  label,
  serviceTag,
  postReview,
  virtualUser,
  consultantReview,
  systemControl,

  salesPerson,
  performance
} from "./export";

// 进度条动画
import NProgress from "nprogress";
import "nprogress/nprogress.css";
NProgress.configure({
  showSpinner: false
});
Vue.use(Router);

// 公共路由配置
const router = new Router({
  routes: [{
      path: "/",
      redirect: "/login",
      name: "登录"
    },
    {
      path: "/login",
      name: "login",
      component: () => import("@/page/login/login.vue")
    },
    {
      path: "/home",
      name: "主页",
      component: () => import("@/page/home/home.vue"),
      redirect: "/user",
      children: [
        // 权限路由添加此处
        // ---------用户管理-----------
        user, //普通用户管理
        consultant, //咨询师管理

        //-------------订单管理------------
        orderrecord, //订单记录
        returnrecord, //退单记录
        financialSettlement, //结算
        //-------------业务管理------------
        card, //会员卡管理
        prepaid, //充值记录

        //-------------审核管理------------
        postReview, //广告管理
        consultantReview,
        notice, //公告管理
        control, //监控管理

        // ---------系统管理-----------
        label, // 标签管理
        serviceTag,
        systemControl,
        virtualUser,
        salesPerson,
        performance
      ]
    },
    {
      path: "/401",
      component: () => import("@/page/401.vue")
    },
    {
      path: "*",
      component: () => import("@/page/404.vue")
    }
  ]
});

//路由跳转前
router.beforeEach((to, from, next) => {
  NProgress.start();
  if (to.path === "/login") {
    next();
  } else {
    const token = sessionStorage.getItem("token");
    if (!token) {
      next("/login");
    } else {
      next();
    }
  }
});

//路由跳转后
router.afterEach(() => {
  NProgress.done();
});

// 根据权限  对路由动态添加
export function initDynamicRoute() {
  //拿到home路由下的children
  const currentRoutes = router.options.routes;
  //拿到储存在vuex中的权限信息
  const rightList = store.state.rightList;
  // 对权限信息进行处理,找到与之匹配的  路由
  rightList.forEach(item => {});
  //动态的添加到路由中
  // currentRoutes[2].children.push()
  router.addRoutes(currentRoutes);
}
export default router;



// WEBPACK FOOTER //
// ./src/router/index.js